import {
  Waves,
  Compass,
  Wind,
  Snowflake,
  Hand,
  Sun,
  Sparkles,
  Utensils,
  Wine,
  IceCream2,
  Gift,
} from 'lucide-react'
import type { LucideIcon } from 'lucide-react'

export interface TeamBuildingActivity {
  id: string
  icon: LucideIcon
  title: string
  tagline: string
  description: string
  /** Photos are added later — the card falls back to an icon block when empty. */
  images?: string[]
}

export const teamBuildingActivities: TeamBuildingActivity[] = [
  {
    id: 'sup',
    icon: Waves,
    title: 'פעילות סאפ — ספורטיבית או חופשית',
    tagline: 'מתאים גם למי שמעולם לא עלה על סאפ',
    description:
      'מתחילים בהדרכה קצרה ומקצועית על החוף, ומשם הקבוצה בוחרת את הקצב: מקצים ספורטיביים, משחקי קבוצה ותחרויות ידידותיות על המים — או חתירה חופשית ורגועה בקצב של כל אחד. כל הציוד, אפודי הציפה והליווי המקצועי כלולים.',
    images: [
      'https://cdn.magicpatterns.com/uploads/tYRf27788nyrtTYPxGbd1k/EliteHenensonPhoto_20260612_Sup_Club_Maagan_037.jpg',
    ],
  },
  {
    id: 'tours',
    icon: Compass,
    title: 'טיולי חתירה על הכנרת',
    tagline: 'המסלול נקבע לפי הרמה של הקבוצה',
    description:
      'יוצאים למסלול חתירה מודרך לאורך קו החוף, עם עצירות לשחייה, סיפורים על האזור ורגעים של שקט מוחלט באמצע המים. אפשר טיול נינוח של שעה, ואפשר מסלול ארוך ומאתגר יותר — אנחנו מתאימים את המרחק והקצב לקבוצה.',
    images: [
      'https://cdn.magicpatterns.com/uploads/oEVxgJviEkQoRs3fbmiVkq/EliteHenensonPhoto_20260612_Sup_Club_Maagan_203.jpg',
      'https://cdn.magicpatterns.com/uploads/69aEDpi4ufDSN5evFsBDnM/EliteHenensonPhoto_20260612_Sup_Club_Maagan_271.jpg',
    ],
  },
  {
    id: 'movement',
    icon: Wind,
    title: 'סשן תנועה ונשימה — במים או ביבשה',
    tagline: 'פתיחה רכה ליום או סגירה מרגיעה',
    description:
      'מפגש מונחה שמחבר בין גוף לנשימה: יוגה על הסאפ מעל המים, או סשן תנועה ומתיחות על המדשאה מול הכנרת. מותאם לכל רמות הגמישות והניסיון, בלי צורך ברקע קודם — רק להגיע ולנשום.',
    images: [
      'https://cdn.magicpatterns.com/uploads/5uSzxeLLT4FWX8MtQW8kBb/EliteHenensonPhoto_20260612_Sup_Club_Maagan_013.jpg',
      'https://cdn.magicpatterns.com/uploads/m1BC8vbhq1ZEtQzK2viGXv/EliteHenensonPhoto_20260612_Sup_Club_Maagan_144.jpg',
    ],
  },
  {
    id: 'ice',
    icon: Snowflake,
    title: 'סדנת נשימה מודעת ואמבטיית קרח',
    tagline: 'החוויה שהקבוצות הכי מדברות עליה אחר כך',
    description:
      'סדנה מונחית בשיטות נשימה מודעת, ואחריה כניסה מדורגת לאמבטיית קרח בליווי צמוד ובטוח. חוויה קבוצתית עוצמתית שמלמדת להתמודד עם אי-נוחות ולחץ מתוך שליטה ורוגע — ומייצרת שיחות אחרות לגמרי בין אנשי הצוות.',
    images: [
      'https://cdn.magicpatterns.com/uploads/t62txN2MRteYKZ162bJMiU/64f7e3f5-7e80-4126-a9c5-4e0a864269fb.jpg',
      'https://cdn.magicpatterns.com/uploads/63ZqSRiJQebABahUYKKKKe/c2d514d7-94f5-465f-b584-8a0ff5e4d462.jpg',
    ],
  },
  {
    id: 'massage',
    icon: Hand,
    title: 'מתחם עיסויים',
    tagline: 'פינוק אישי בלי לעצור את היום',
    description:
      'מתחם עיסויים מקצועי בתוך המתחם, עם מטפלים מנוסים ומיטות טיפול מול הנוף. משבצים את המשתתפים בתורות לאורך היום, כך שכל אחד מקבל את הפינוק שלו בזמן ששאר הקבוצה ממשיכה בפעילות.',
    images: [
      'https://cdn.magicpatterns.com/uploads/bZKmrRD9VhS2s3JN2cLmBn/9868cc03-39bc-4374-8ac2-644c9bf1eb57.jpg',
      'https://cdn.magicpatterns.com/uploads/w2bC2hENumBEQ7PjWWP2HS/thumbnail_IMG_2735.jpg',
    ],
  },
  {
    id: 'pool',
    icon: Sun,
    title: 'בריכת שחייה וחוף רחצה',
    tagline: 'כניסה חופשית לאורך כל היום',
    description:
      'כניסה חופשית לבריכת השחייה ולחוף הרחצה של כפר הנופש לאורך כל היום. זמן חופשי לשחייה, שיזוף, ישיבה בצל ופשוט להיות ביחד — בלי לוח זמנים ובלי לחץ.',
    images: [
      'https://cdn.magicpatterns.com/uploads/5gQyF8xqmBvwjHxftf61j3/2012-04-12-MAAGAN-058.jpg',
      'https://cdn.magicpatterns.com/uploads/5Z9CQCvpFR1aqKfsWrunHi/Mahagan_erezbit0005-1.jpg',
    ],
  },
  {
    id: 'custom',
    icon: Sparkles,
    title: 'ועוד המון רעיונות משלכם',
    tagline: 'הרשימה הזאת היא רק ההתחלה',
    description:
      'סאונד הילינג על המדשאה, סדנת אומנות על החוף, הרצאה, טקס הוקרה או מסורת של החברה — ספרו לנו מה אתם רוצים לשלב ונבנה אותו לתוך היום. אנחנו רגילים להרכיב ימים סביב בקשות מיוחדות.',
    images: [
      'https://cdn.magicpatterns.com/patterns/generated-images/9c76bdb2-baa3-4b47-ac7e-24879079f07c.jpg',
      'https://cdn.magicpatterns.com/patterns/generated-images/234e21a4-5c0f-456b-85a7-ba92615bfaab.jpg',
    ],
  },
]

export interface TeamBuildingExtra {
  icon: LucideIcon
  title: string
  description: string
}

export const teamBuildingExtras: TeamBuildingExtra[] = [
  {
    icon: Utensils,
    title: 'ארוחות ממגוון תפריטים',
    description:
      'בוקר, צהריים או ערב — בוחרים מתוך מגוון תפריטים ומתאימים לצרכים התזונתיים של הקבוצה.',
  },
  {
    icon: Wine,
    title: 'בר ואלכוהול',
    description:
      'אפשר להוסיף בר משקאות ואלכוהול לשעות אחר הצהריים והערב, בהתאם לאופי האירוע.',
  },
  {
    icon: IceCream2,
    title: 'ארטיקים לאורך היום',
    description:
      'ארטיקים קרים בדיוק ברגע הנכון של היום — קטן, ועושה הבדל ענק בחום של הכנרת.',
  },
  {
    icon: Gift,
    title: 'פינוקים ותוספות',
    description:
      'פירות, קפה, מתוקים ופינוקים נוספים שאפשר לשלב בכל שלב של היום.',
  },
]

export interface TeamBuildingStep {
  title: string
  description: string
}

export const teamBuildingSteps: TeamBuildingStep[] = [
  {
    title: 'שיחה קצרה',
    description:
      'מספרים לנו על הקבוצה: כמה אתם, מה האופי, מה חשוב לכם שיקרה ביום הזה.',
  },
  {
    title: 'הצעה מותאמת',
    description:
      'אנחנו בונים לכם הצעה עם לוח זמנים, פעילויות ואוכל — ומדייקים אותה יחד איתכם.',
  },
  {
    title: 'יום מושלם',
    description:
      'אתם מגיעים, ואנחנו מנהלים את היום מא׳ ועד ת׳. אתם רק צריכים להיות נוכחים.',
  },
]
